import React from 'react';
import Layout from '../../shared/components/Layout';
import CompanyOverviewMain from '../components/CompanyOverviewMain';

const CompanyOverview = () => {
  return (
    <React.Fragment>
      <Layout>
        <CompanyOverviewMain />
      </Layout>
    </React.Fragment>
  );
};

export default CompanyOverview;
